import Lenis from 'lenis';
import { gsap } from '../gsap-3.13.0.min';
import { ScrollTrigger } from '../ScrollTrigger.min';

export default {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });

    const lenis = new Lenis({
      duration: 1.1,
      wheelMultiplier: 1.0,
      smoothTouch: true,
      prevent: (node) => node.closest('[data-lenis-prevent]') !== null,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    lenis.on('scroll', () => {
      ScrollTrigger.update();
    });

    ScrollTrigger.scrollerProxy(document.documentElement, {
      scrollTop(value) {
        if (arguments.length) lenis.scrollTo(value, { immediate: true });
        else return window.scrollY || document.documentElement.scrollTop;
      },
      getBoundingClientRect() {
        return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
      },
    });
    ScrollTrigger.refresh();
  },
};
